import React from "react";
import SubmitButton from "../SubmitButton";
import { labels } from "../../../localization/labels";
import { Form, Row, Col, FormGroup, FormLabel } from "react-bootstrap";
import PromiseBar from "../PromiseBar";
import { Affix } from "antd";

const getFileNames = files => {
  var names = files.length + " " + labels.selectedFilesNum + ": ";

  for (var i = 0; i < files.length; i++) {
    names += '"' + files[i].name + '"';

    names += i < files.length - 1 ? ", " : "";
  }

  return names;
};

const FileUploader = ({
  multiple = false,
  selected,
  onSelect,
  onUpload,
  promiseBarRef,
  inputRef,
  disabled = false
}) => {
  const hasSelected = selected.length > 0;
  const filesLabel = hasSelected
    ? getFileNames(selected)
    : labels.selectFiles + "...";

  return (
    <div className="FileUploader">
      <Form onSubmit={onUpload}>
        <div className="custom-file mb-3">
          <input
            type="file"
            className="custom-file-input"
            id="customFile"
            multiple={multiple}
            onChange={onSelect}
            ref={inputRef}
          />
          <FormLabel className="custom-file-label" for="customFile">
            {filesLabel}
          </FormLabel>
        </div>
        <FormGroup as={Row} className="align-items-center">
          <Col md="4" sm="12">
            <Affix offsetBottom={true}>
              <SubmitButton
                block
                text={labels.upload}
                disabled={!hasSelected || disabled}
              />
            </Affix>
          </Col>
          <Col md="8" sm="12">
            <PromiseBar ref={promiseBarRef} />
          </Col>
        </FormGroup>
      </Form>
    </div>
  );
};

export default FileUploader;
